import { React } from 'react';
import styled from 'styled-components';

export default function DeductionCountInput(props) {
  const { disabled, value, setValue, width } = props;

  function handleChange(e) {
    const curValue = e.target.value
    const newValue = curValue.replace(/[^0-9]/g, '')

    if (newValue < 9999999)
      setValue(newValue);
  }

  function handleFocus() {
  }

  function handleBlur() {
  }

  return (
    <TopLevelWrapper width={width}>
      <InputWrapper>
        <Input
          placeholder='1'
          value={value || ''}
          disabled={disabled}
          onFocus={handleFocus}
          onChange={handleChange}
          onBlur={handleBlur} />
      </InputWrapper>
        <Text>회</Text>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: ${props => props.width}px;

  gap: 4px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 27px);
  height: 30px;

  border: 1px solid #B2B2B2;
  border-radius: 5px;
`;

const Input = styled.input`
  width: 100%;
  height: 100%;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0px;
  padding: 0px;

  text-align: right;

  border: 0px solid #DFDFDF;
  border-radius: 5px;
  outline: none;

  color: #000000;
  background-color: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};

  transition: all 0.3s ease-in-out;

  ::placeholder {
    color: #CBCBCB;
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  margin: 0 0 0 0;
`;
